//#region imports
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { isLoggedIn, getLoggedInUser } from "../services/AuthenticationService";
import i18n from "../i18n";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { InputText, Dropdown, Loading, Valert, Vmodal } from "../components";
import { Row, Col } from "reactstrap";
import forumActions from "../actions/forumActions";
import moment from "moment";
import { formatNumber } from "../lib/helper";
import {
  singlePostGet,
} from "../services/ForumService";
//#endregion
const ForumItem = ({ data, checkStatusForRedirect }) => {
  return (
    <div className="forumItem">
      <Row>
        <Col xs="11" className="dateTime">
          {data.date ?
            moment.unix(data.date).format("DD MMM YYYY, hh:mma") : moment(data.created_at).format("DD MMM YYYY, hh:mma")}
        </Col>
        <Col xs="1" className="vote yesVote" style={{ cursor: "default" }}>
          <div style={{ display: "inline", position: "relative", marginLeft: '-40px' }} ><i className="fa fa-check-circle" /></div>
          <div style={{ display: "inline", position: "relative" }}>
            {formatNumber(data.relevant.up)}/{formatNumber(data.relevant.up + data.relevant.down)}
          </div>
        </Col>
      </Row>
      <p 
        // style={{ whiteSpace: "pre-wrap" }}
      >
        <span style={{ color: "red" }}>
          {data.publish_status == "republished" ? i18n.t("forum.EDITED_TEXT") : ""}
          {" "}
        </span>
        <span style={{ whiteSpace: "pre-wrap" }}>
          {data.body}
        </span>
      </p>
      <div>
        {data.related &&
          data.related.map((item) => {
            return (
              <a className="relatedPosts" onClick={() => checkStatusForRedirect(item)}>
                {item}
              </a>
            );
          })}
      </div>
    </div>
  );
};

class ForumSingle extends Component {
  constructor(props) {
    super(props);
    this.state = { textAreaPlaceHolder: "Please select a symptom" };
    this.askDeleteCaller = this.askDeleteCaller.bind(this);
    this.checkStatusForRedirect = this.checkStatusForRedirect.bind(this);
    this.redirectLink = "";
  }
  componentDidMount() {
    if (!isLoggedIn()) {
      this.props.history.push("/");
      return;
    }
    if (this.props.match.params.postId) {
      this.props.forumSinglInitialization(this.props.match.params.postId);
    }
    this.loggedInUser = getLoggedInUser();
  }

  async checkStatusForRedirect(item) {
    this.redirectLink = item;
    const data = await singlePostGet(this.redirectLink);
    this.redirectToLink(data)
  }
  redirectToLink(data) {
    if (data) {
      const { publish_status } = data;
      if (publish_status == 'irelevant') {
        this.irrelevantPost.changeStatus();
      } else {
        window.location.href = `/forum/post/${this.redirectLink}`
      }
    }
  }
  inputPlaceHolderMaker() {
    if (
      this.props.forumFiltersForm.symptom &&
      this.props.forumFiltersForm.symptom != "null"
    ) {
      let result = "";
      if (this.props.symptomsList) {
        this.props.symptomsList.forEach((element) => {
          if (
            this.loggedInUser &&
            this.loggedInUser.lang &&
            this.loggedInUser.lang === "1200000000001000015"
          ) {
            result = `分享我${element.label}的经验`;
          } else if (
            this.loggedInUser &&
            this.loggedInUser.lang &&
            this.loggedInUser.lang === "1200000000001000016"
          ) {
            result = `分享我${element.label}的經驗`;
          } else {
            result = `Enter your experience about ${element.label} here.`;
          }
        });
      }
      return result;
    } else {
      return "Please select a symptom";
    }
  }
  askDeleteCaller(id) {
    this.deleteId = id;
    this.deleteValert.changeStatus();
  }
  render() {
    const { isLoading, singlePostItem, t } = this.props;
    let title = "";
    if (singlePostItem) {
      title =
        this.props.t("forum.SELECTED_POST_TEXT") +
        ` (ID: ${singlePostItem._id})`;
    }
    return (
      <div className="vPage mealPlannerPage flex">
        <Loading isLoading={isLoading} />
        <Valert
          display={false}
          title={t("forum.IRRELEVANT_POST_DELETED_TITLE")}
          question={t("forum.IRRELEVANT_POST_DELETED_TEXT")}
          onRef={(ref) => (this.irrelevantPost = ref)}
          positiveText={t("general.OK_PROMPT_TEXT")}
          positiveAction={() => { return true; }}
          readOnly={true}
        />
        <Row>
          <Col className="myForumTitle">
            <h3>{title}</h3>
          </Col>
        </Row>
        <div className="grayList forumGrid" style={{ flex: 1 }}>
          {singlePostItem && <ForumItem data={singlePostItem} checkStatusForRedirect={this.checkStatusForRedirect} />}
        </div>
        <Row>
          <Col>
            <button
              className="btn btn-primary btnWide"
              onClick={() => {
                window.location.href = "/forum";
              }}
            >
              {this.props.t("forum.COMMUNITY_PAGE")}
            </button>
          </Col>
        </Row>
      </div>
    );
  }
}
//#region exports

const mapStateToProps = (state) => ({
  ...state.forumReducer,
});
ForumSingle = translate("translations")(ForumSingle);

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...forumActions }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(ForumSingle);



// WEBPACK FOOTER //
// ./src/pages/ForumSingle.js